export const Camera = {
    getCameraPermissionStatus: () => 'unavailable',
};
export const useCameraDevice = (_position) => undefined;
export const useCodeScanner = (config) => config;
